import React, {useEffect, useState} from "react";

import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Form } from "react-bulma-components";
import {formatDate} from "../../utils";
import { Button } from "react-bulma-components";
import GenerateFleetModal from "./GenerateFleetModal";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import VehicleMakePicker from "./VehicleMakePicker";
import VehicleModelPicker from "./VehicleModelPicker";
import FAIcon from "../Icon/FAIcon";
import DepartmentPicker from "../Job/DepartmentPicker";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";

const AsyncTypeahead = asyncContainer(Typeahead);

function VehicleInfoSection(props) {
  const [generateFleetModalState, setGenerateFleetModalState] = useState({modalOpen: false});
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [hireCustomer, setHireCustomer] = useState();
  const [filteredModels, setFilteredModels] = useState(props.vehicleModel);
  const [, setTypeahead] = useState();
  const vehicleMake = props.vehicleMake;
  const departments = props.departments;

  useEffect(() => {
    handleModelFilter(props.data.make ? props.data.make : "");
  }, []);

  const vehicleMakeObjects = vehicleMake.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});

  const vehicleModelObjects = filteredModels.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});

  const departmentObjects = props.departmentObjects;

  const typeFields = props.vehicleTypes;
  const typeObjects = typeFields.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});

  const handleTypeUpdate = e => {
    const toUpdate = {
      target: {
        name: "type",
        value: typeObjects[e.target.value]
      }
    };
    props.onChange(toUpdate);
  };

  const handleDepartmentChange = e => {
    const toUpdate = {
      target: {
        name: "department",
        value: departmentObjects[e.target.value]
      }
    };
    props.onChange(toUpdate);
  }

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=CC&page_size=40&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleModelFilter = (make) => {
    const conf = {
      method: "get",
      url: props.endpoint + "vehiclemodel?page_size=1000&make="+(make ? make.id : "")
    }
    axios(conf).then(res => {
      setFilteredModels(res.data)
    })
  }


  const handleCustomerSelect = e => {
    const toUpdate = {
      target: {
        name: "hire_customer",
        value: e[0]
      }
    }
    props.onChange(toUpdate)
  }

  const handleMakeChange = e => {
    let isBlank = e.target.value === 'BLANK' && e.target.key === -1;
    const toUpdate = {
      target: {
        name: "make",
        value: isBlank ? {} : vehicleMakeObjects[e.target.value]
      }
    }
    props.onChange(toUpdate)
    handleModelFilter(isBlank ? null : vehicleMakeObjects[e.target.value])
  }
  const handleModelChange = e => {
    let isBlank = e.target.value === 'BLANK' && e.target.key === -1;
    const toUpdate = {
      target: {
        name: "model",
        value: isBlank ? {} : vehicleModelObjects[e.target.value]
      }
    }
    props.onChange(toUpdate)
  }

  const onHireCustomerClear = e => {
    const toUpdate = {
      target: {
        name: "hire_customer",
        value: null
      }
    }
    props.onChange(toUpdate)
  }

  return (
    <Box>
      <h1 className="title">Vehicle Info</h1>
      <Columns>
        <Columns.Column>
          <Form.Control>
            <Form.Label>Vehicle Status</Form.Label>
            <Button
              color={
                props.data.vehicle_status === "EQUIPMENT" ? "primary" : ""
              }
              onClick={() => props.handleStatus("EQUIPMENT")}
            >
              Equipment
            </Button>
            <Button
              color={
                props.data.vehicle_status === "ACTIVE" ? "primary" : ""
              }
              onClick={() => props.handleStatus("ACTIVE")}
            >
              Active
            </Button>
            <Button
              color={
                props.data.vehicle_status === "ORDERED" ? "primary" : ""
              }
              onClick={() => props.handleStatus("ORDERED")}
            >
              Ordered
            </Button>
            <Button
              color={
                props.data.vehicle_status === "SALES_STOCK"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("SALES_STOCK")}
            >
              Sales Stock
            </Button>
            <Button
              color={
                props.data.vehicle_status === "FORSALE"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("FORSALE")}
            >
              For Sale
            </Button>
            <Button
              color={
                props.data.vehicle_status === "PENDING_SALE"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("PENDING_SALE")}
            >
              Pending Sale
            </Button>
            <Button
              color={
                props.data.vehicle_status === "PROCESSING"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("PROCESSING")}
            >
              Processing Sale
            </Button>
            <Button
              color={
                props.data.vehicle_status === "SOLD" ? "primary" : ""
              }
              onClick={() => props.handleStatus("SOLD")}
            >
              Sold
            </Button>
            <Button
              color={
                props.data.vehicle_status === "CUSTOMER"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("CUSTOMER")}
            >
              External Customer Vehicle
            </Button>
          </Form.Control>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>LCV Sold</Form.Label>
            <input
              className="checkbox"
              type="checkbox"
              name="lcv_sold"
              onChange={props.handleCheckbox}
              checked={props.data.lcv_sold}
            />
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
            <Form.Label>Sales Prep</Form.Label>
            <Form.Checkbox
                name={"sales_prep"}
                checked={props.data.sales_prep}
                onChange={props.handleCheckbox}
                disabled={(props.data.vehicle_status !== "SALES_STOCK")}
            />
        </Columns.Column>
        <Columns.Column>
          <DepartmentSelector
            name={"department"}
            label={"Department"}
            value={props.data.department}
            options={departments}
            blank={false}
            disabled={false}
            classname={""}
            inlineEdit={false}
            editable={true}
            onChange={handleDepartmentChange}
          />
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Form.Field>
            <Form.Label className="label">Registration</Form.Label>
            <Form.Control>
              <Form.Input
                type="text"
                name="registration"
                onChange={props.onChange}
                value={props.data.registration}
                required
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <VehicleMakePicker
            onChange={handleMakeChange}
            vehicle={props.data}
            makes={vehicleMake}
          />
        </Columns.Column>
        <Columns.Column>
          <VehicleModelPicker
            onChange={handleModelChange}
            vehicle={props.data}
            models={filteredModels}
            showTitle={true}
            disabled={false}
          />
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Variant</Form.Label>
              <Form.Input
                type="text"
                name="variant"
                onChange={props.onChange}
                value={props.data.variant}
                required
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>VIN Number</Form.Label>
              <Form.Input
                type="text"
                name="vin_number"
                onChange={props.onChange}
                value={props.data.vin_number}
                required
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Type</Form.Label>
              <Form.Select
                onChange={handleTypeUpdate}
                name="type"
                value={props.data.type ? props.data.type.id : typeFields[0].id}
              >
                {typeFields.map(value => (
                  <option key={value.id} value={value.id}>
                    {value.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Date of First Registration</Form.Label>
              <Form.Input
                type="date"
                name="first_registration_date"
                onChange={props.onChange}
                value={
                  props.data.first_registration_date
                  || ""
                }
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Form.Label>Fleet Number</Form.Label>
          <Form.Field className="has-addons">
            <Form.Control>
              <Form.Input
                type="text"
                name="fleet_number"
                onChange={props.onChange}
                value={props.data.fleet_number}
                required
              />
            </Form.Control>
            <Form.Control>
              <Button
                color={"success"}
                onClick={() => setGenerateFleetModalState({modalOpen: true})}
              >Generate</Button>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Mileage</Form.Label>
            <Form.Control>
              <Form.Input
                type="number"
                name="mileage"
                onChange={props.onChange}
                value={String(props.data.mileage)}
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Last Mileage Update</Form.Label>
              <Form.Input
                type="date"
                name="mileage_last_updated"
                disabled
                readOnly
                value={
                  props.data.mileage_last_updated
                    ? formatDate(new Date(props.data.mileage_last_updated))
                    : ""
                }
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Company Car</Form.Label>
            <input
              className="checkbox"
              type="checkbox"
              name="company_vehicle"
              onChange={props.handleCheckbox}
              checked={props.data.company_vehicle}
            />
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Location</Form.Label>
              <Form.Input
                type="text"
                name="location"
                onChange={props.onChange}
                value={props.data.location}
                required
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Control>
              <Form.Label>Purchase Date</Form.Label>
              <Form.Input
                type="date"
                name="purchase_date"
                onChange={props.onChange}
                value={
                  props.data.purchase_date || ""
                }
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
      </Columns>
      <Columns>
        <Columns.Column>
          <Form.Field>
              <Form.Label>Hire Customer</Form.Label>
              <Form.Control>
                <AsyncTypeahead
                  useCache={false}
                  data-testid="hire-customer-search"
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"hire_customer"}
                  onSearch={handleSearch}
                  onChange={handleCustomerSelect}
                  placeholder={"Search Customers"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                />
              </Form.Control>
            </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Label>Hire Customer Name</Form.Label>
          <Form.Field className={"has-addons"}>
            <Form.Control>
              <Form.Input
                readOnly={true}
                disabled={true}
                value={props.data.hire_customer ? props.data.hire_customer.display_name : ""}
              />
            </Form.Control>
            <Form.Control>
              <Button
                color={"danger"}
                onClick={onHireCustomerClear}
              >
                Clear
              </Button>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column/>
        <Columns.Column/>
        <Columns.Column/>
        <Columns.Column/>
      </Columns>
      <GenerateFleetModal
        {...generateFleetModalState}
        setModalState={setGenerateFleetModalState}
        endpoint={props.endpoint}
        onChange={props.onChange}
        initDate={props.data.delivery_date}
      />
    </Box>
  );
}

export default VehicleInfoSection;
